export default {
      id: "icon-smiley-confus-usage",
      viewBox: "0 0 145.5 142.5",
      url: __webpack_public_path__ + "icons.svg#icon-smiley-confus",
      toString: function () {
        return this.url;
      }
    }